import React, { useEffect } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import TopPage from 'v2/components/Shared/TopPage';
import useGetUser from 'v2/hooks/useGetUser';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { Cards } from './Cards';

export const Reports = () => {
  const user = useGetUser();
  const [tours] = useObservable(() => eduzzAccountsService.getTours(), []);
  const [loadingTours] = useObservable(() => eduzzAccountsService.getLoadingTours(), []);
  const [saveTour] = useCallbackObservable(tour => eduzzAccountsService.saveTourAction(tour), []);
  const [isLoadingAccount] = useObservable(() => eduzzAccountsService.getLoadingAccount(), []);

  useEffect(() => {
    const tourName = 'new_sales_reports';

    const userDidntSeeTour = tours !== null && !tours?.includes(tourName);
    const userIsNotSupport = user !== null && !user.is_support;
    const shouldSave = userDidntSeeTour && userIsNotSupport && !loadingTours;

    if (shouldSave) {
      saveTour(tourName);
    }
  }, [loadingTours, tours, user, saveTour]);

  if (isLoadingAccount || !user) return null;

  return (
    <>
      <TopPage
        title='Relatórios'
        extra='Tenha todas as informações que precisa para seu negócio digital'
        disableAlerts
      />
      <Cards />
    </>
  );
};
